import React, { useState, useEffect, useContext } from 'react';
import { Container } from 'react-bootstrap';
import MainComponent from './components/Main/main.component';
import Footer from './components/General/Static/Footer';
import Header from './components/General/Static/Header';
import ErrorPage from './components/loginTypes/ErrorPage';
import BiometricIDLogin from './components/loginTypes/BiometricID/Login/BiometricIDLogin';
import SmartCardLogin from './components/loginTypes/SmartCard/Login/SmartCardLogin';
import LoginContext from './store/login-context';
import CacheBuster from 'react-cache-buster';
import packageInfo  from '../package.json';
import './App.scss';
import RegistrationContentComponent from './components/Registration/Registration-content/Registration-content.component';
import DetailsCompletion from './components/Form/DetailsCompletion/DetailsCompletion';
import GovSpinner from './components/Form/GovSpinner';
import Success from './components/General/Static/Success';
import PreRegContainer from './components/Registration/PreRegistration/PreRegContainer/PreRegContainer';
import OnlineServicesLarge from './components/General/Static/OnlineServices/OnlineServicesLarge';


declare function Translate(key: string): string;
declare var _loginTypeSMSOTP: any; 
declare var _loginTypeSmartphoneOTP: any;
declare var _loginTypeIsraelDigitalIDCard: any;
declare var _errorPageType: any;
declare var _loginType: any;
declare var _loginTypeLoa4Landing: any;
declare var _loginTypePki: any;
declare var _loginTypePkiTamuz: any;
declare var	_loginTypePkiComsign: any;
declare var	_loginTypePkiPersonalID: any;
declare var _loginTypeWebAuthn: any;
declare var _loginTypePreRegCheck:any;
declare var _loginMethodWebauthnUrl: any;
declare var _loginMethodSmsOtpUrl: any;

declare function LoadTranslation(lang?: string): Promise<void>;
declare var _curLang: any;

function useForceUpdate() {
  let [value, setState] = useState(true);
  return () => setState(!value);
}

const App = () => {    
  const [loading, setLoading] = useState(true);      
  
  //*** This context is needed to reload app.tsx when context and _loginType changed */
  //*** like when clicking on the link 'to old smart card process' in SmartCardInstall.tsx */ 
  const ctx = useContext(LoginContext);

  useEffect(() => {

    //Afetr removing application redirect to smsOtp
    if(_loginType === _loginTypeSmartphoneOTP){
      window.location = _loginMethodSmsOtpUrl;
    }
    
    // preferred login: passKey
    if(localStorage.getItem('preferredLoginType') === _loginTypeWebAuthn && 
      _loginType !==_loginTypeWebAuthn &&
      _loginType !== _loginTypeLoa4Landing
      ){
      window.location = _loginMethodWebauthnUrl;
    }
        
  },[]);
  
  useEffect(() => {
    onComponentMount();
  },[]);

  useEffect(() => {
    document.title = Translate('N_General_system_title_1');
  }, [_curLang]);

  useEffect(() => {
     // preferred login: bio id
    if(localStorage.getItem('preferredLoginType') === _loginTypeIsraelDigitalIDCard && _loginType !==_loginTypeIsraelDigitalIDCard){
      ctx.bioIdSelected();      
    } 
    
    // preferred login: smart card
    if(localStorage.getItem('preferredLoginType') === _loginTypePkiTamuz && _loginType !==_loginTypePkiTamuz){
      ctx.scSelected();      
    }
    if(localStorage.getItem('preferredLoginType') === _loginTypePkiComsign && _loginType !==_loginTypePkiComsign){
      ctx.scSelected();      
    }
    if(localStorage.getItem('preferredLoginType') === _loginTypePkiPersonalID && _loginType !==_loginTypePkiPersonalID){
      ctx.scSelected();      
    }
    if(_loginType === _loginTypeLoa4Landing){
      if(ctx.isBioIdClicked){
        ctx.bioIdSelected();
      }
      else{
        ctx.scSelected();
      }
    }
  },[ctx]);
    
  const handleForceupdateMethod = useForceUpdate();

  async function onComponentMount(){
    await LoadTranslation();  
    setLoading(false);
    document.title = Translate('N_General_system_title_1');    
  }

  const update = () => {
    handleForceupdateMethod();
  };
       
  return (  
    <React.Fragment>    
      {loading && <GovSpinner show={loading} /> }

      {ctx.isSuccess && 
        <div className='top-container'>                         
          <Header
            showLogo={true}
            forceUpdate={update}
            isBiometricHeader={false}
          />                           
          <Container >
            <Success />            
          </Container>
          <Container
            fluid
            className='footer-container'
          >
            <Footer />
          </Container>                          
        </div>
      } 
      
      {!loading && !ctx.isSuccess && 
        <>   
          <CacheBuster
            currentVersion={packageInfo.version}
            isEnabled={true}
            onCacheClear={() => {}}
          >
          {
            (() => {
              switch (_loginType) {
                case _loginTypeSMSOTP:                
                case _loginTypeLoa4Landing: 
                case _loginTypeWebAuthn:
                case _loginTypePreRegCheck: 
                  return (
                    <>                     
                      {ctx.loginNeededInfo.length === 0 && 
                        <div className='top-container'>                         
                            <Header
                              showLogo={true}
                              forceUpdate={update}
                              isBiometricHeader={false}
                            />                           
                            <Container >
                              {!ctx.isSuccess && !ctx.showRegFormOptions && _loginType !== _loginTypePreRegCheck && <MainComponent />  }
                              {ctx.showRegFormOptions && <RegistrationContentComponent />}  
                              {_loginType === _loginTypePreRegCheck && !ctx.showRegFormOptions && <PreRegContainer />}                                                           
                            </Container>
                            <Container>
                              {ctx.showRegFormOptions &&<OnlineServicesLarge></OnlineServicesLarge>}
                            </Container>
                            <Container
                              fluid
                              className='footer-container'
                            >
                              <Footer />
                            </Container>                          
                        </div>
                      }
                     
                      {ctx.loginNeededInfo.length > 0 &&                                             
                        <DetailsCompletion                          
                          neededInfo={ctx.loginNeededInfo}
                          currentState={ctx.currentState}
                          forceUpdate={update}
                        />
                      }                     
                    </>                                        
                  );
                case _loginTypeIsraelDigitalIDCard:
                  return <BiometricIDLogin forceUpdate={update}/>;
                case _loginTypePki:
                case _loginTypePkiTamuz:
                case _loginTypePkiComsign:
                case _loginTypePkiPersonalID:
                  return <SmartCardLogin forceUpdate={update}/>;                
                case _errorPageType:
                  return <ErrorPage />;

                default:
                  return (
                    <div className='top-container'>
                      <Container fluid className='px-0'>
                        <Header
                          showLogo={true}
                          forceUpdate={update}
                          isBiometricHeader={false}
                        />
                        <Container >
                          <MainComponent />
                        </Container>
                        <Container
                          fluid
                          className='footer-container'
                        >
                          <Footer />
                        </Container>
                      </Container>
                    </div>
                  );
              }                
            })()          
        }
        </CacheBuster>       
        </>
      }
    </React.Fragment>
  );
 
};
export default App;
